import * as UI from '@brewlogix/blx-ui'
import * as CC from '@chakra-ui/react'
import classNames from 'classnames'
import React from 'react'
import { parseStateLabel } from 'src/features/BrewDetail/util/helpers'
import { Location } from 'src/types/schema/graphql'

import CardActions from './CardActions'

interface ICardHeader {
    location: Location
    type?: 'popup' | 'result'
    distance?: number
    showFavoriteAction?: boolean
    showRouteAction?: boolean
}

const CardHeader: React.FC<ICardHeader> = ({
    location,
    type = 'result',
    showFavoriteAction = true,
    showRouteAction = true,
    distance,
}) => {
    const parsedAddress = location?.address
        ? [location.address.street, location.address.city, parseStateLabel(location.address.state)]
              .filter((item) => item && item !== '')
              .join(', ')
        : ''

    return (
        <CC.CardHeader className='card__header pb-0' p='0'>
            <div className='card__image h-12 w-12'>
                {location?.brand?.assets[0] && (
                    <UI.Media
                        asset={location?.brand?.assets[0]}
                        customWrapperClasses={classNames(
                            'mx-auto object-cover rounded-md h-12 w-12 media media--logo card__logo'
                        )}
                        width={48}
                        height={48}
                        alt={`Logo for ${location?.brand?.displayTitle || location?.brand?.title}`}
                    />
                )}
            </div>

            <div className={classNames('card__header-text card__header-text--labeled w-full')}>
                <CC.Heading as='h2' size='md' mb='0.5' fontWeight='bold' fontSize='lg'>
                    {location?.title || location?.brand?.displayTitle || location?.brand?.title}
                </CC.Heading>
                <CC.Heading as='h4' size='sm' mb='2' fontSize='sm' fontWeight='normal'>
                    {location?.brand?.displayTitle || location?.brand?.title}
                </CC.Heading>
                <p className='card__subtitle mt-0'>{parsedAddress}</p>
                {distance && distance !== null && (
                    <p className={classNames('text-xs font-bold text-gray-400')}>
                        {distance} miles away
                    </p>
                )}
            </div>
            {(showFavoriteAction || showRouteAction) && (
                <CardActions
                    location={location}
                    type={type}
                    showFavoriteAction={showFavoriteAction}
                    showRouteAction={showRouteAction}
                />
            )}
        </CC.CardHeader>
    )
}
export default CardHeader
